const i18n = require("./i18n")

module.exports = {
    I18n: i18n.i18n,
    exists: i18n.exists,
    t: i18n.t
}